import { render, staticRenderFns } from "./CustomerInProgress.vue?vue&type=template&id=5f2a947c"
import script from "./CustomerInProgress.vue?vue&type=script&lang=js"
export * from "./CustomerInProgress.vue?vue&type=script&lang=js"
import style0 from "./CustomerInProgress.vue?vue&type=style&index=0&id=5f2a947c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports